<!-- 油卡管理 -->
<template>
    <div>
        <template v-if="!isInitialized">
            <div class="block-container">
                <van-empty description="正在读取中..."/>
            </div>
        </template>
        <template v-if="!cardList.length && isInitialized">
            <div class="block-container">
                <van-empty description="暂无卡片"/>
            </div>
        </template>
        <template v-if="cardList.length && isInitialized">
            <van-cell title="选择卡片" is-link @click="cardListSwitch = true"></van-cell>
            <div class="card-container" style="width: 100%;" @click="cardListSwitch = true">
                <card-design :card-info="cardList[cardSelected]" :showLicense="true" style="padding: 10px;"/>
            </div>
            <van-cell v-if="cardInfo.balance !== undefined" title="主卡余额" :value="cardInfo.balance"></van-cell>
            <van-cell v-if="cardInfo.open_data && cardInfo.open_data.wait_refresh_amount" title="待圈存金额" :value="cardInfo.open_data.wait_refresh_amount"></van-cell>
            <van-field v-model="balance" label="划拨金额" placeholder="请输入划拨金额" type="number"/>
            <div style="display: flex;justify-content: center;margin:0.6rem 0;">
                <van-button type="info" class="SubmitBtn" @click="transfer(cardList[cardSelected])">确认划拨</van-button>
            </div>
        </template>

        <van-popup v-model="cardListSwitch" round position="bottom">
            <div class="card-list-title">
                <span>选择需要划拨的卡片</span>
            </div>
            <div class="card-list-content">
                <div v-for="(item, index) in cardList" :key="'card'+index" @click="selectCard(index)" class="card-content" :class="cardSelected === index ? 'card-selected' : 'card-unselected'">
                    <card-design :card-info="item" :showLicense="true" style="padding: 10px;"/>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import api from '../../assets/js/api'
    import cardDesign from '../../components/beilin/CardDesign.vue'

    export default {
        name: 'CompanyCardTransfer',
        components: {cardDesign},
        data () {
            return {
                loading: false,
                isInitialized: false,
                cardList: [],
                cardInfo: {},
                cardSelected: 0,
                cardId: this.$route.query.user_card_id,
                balance: '',
                cardListSwitch: false,
            }
        },
        created() {
            let self = this;
            api.request('/user_card/detail', {
                user_card_id: this.$route.query.user_card_id
            }).then(res => {
                self.cardInfo = res.data;
                api.request('/user_card/query_daughter_card', {
                    user_card_id: this.$route.query.user_card_id
                }).then(res => {
                    self.cardList = res.data;
                    self.isInitialized = true;
                })
            })
        },
        methods: {
            transfer(cardInfo) {
                if (!/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(this.balance)) {
                    this.$dialog.alert({
                        message: `请输入正确的数字`,
                    })
                    return false
                }
                if (this.loading) return false;
                let self = this;
                this.$dialog.confirm({
                    title: '划拨确认',
                    message: `是否划拨${this.balance}元至${cardInfo.card_no}中？`,
                }).then(() => {
                    this.loading = true;
                    let toast = this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        loadingType: 'spinner',
                        duration: 0,
                    });
                    api.request('/user_card/transfer_balance', {
                        user_card_id: this.cardId,
                        transfer_open_id: cardInfo.open_id,
                        amount: this.balance
                    }).then(res => {
                        self.$toast.clear(toast);
                        self.$toast.success(res.msg);
                        self.balance = '';
                    }).catch(res => {
                        self.$toast.clear(toast);
                        self.$toast.fail(res.msg);
                    }).finally(() => {
                        self.refresh();
                    })
                })
            },
            selectCard(index) {
                this.cardSelected = index;
                this.cardListSwitch = false;
            },
            refresh() {
                let self = this;
                api.request('/user_card/detail', {
                    user_card_id: this.$route.query.user_card_id
                }).then(res => {
                    self.cardInfo = res.data;
                    api.request('/user_card/query_daughter_card', {
                        user_card_id: this.$route.query.user_card_id
                    }).then(res => {
                        self.cardList = res.data;
                        self.loading = false;
                    })
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .block-container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: #fff;

        .van-empty {
            padding-top: 0;
        }
    }

    .card-container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        background-color: #fff;
        padding: 0.5rem 0;
    }

    .SubmitBtn {
        margin: 0;
        width: 75vw;
        border-radius: 0.3rem;
    }

    .card-list-title {
        width: 100%;
        height: 1.5rem;
        border: 1px solid #ddd;
        span {
            line-height: 1.5rem;
            display: block;
            text-align: center;
            color: #999;
            font-size: 16px;
        }
    }

    .card-list-content {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        height: 80vh;
        overflow-y: auto;
        .card-content {
            margin: 0.5rem 0;
        }
    }
    
    .card-selected {
        box-shadow: 0 0 30px rgba(255, 194, 25, 0.979);
    }
</style>


// WEBPACK FOOTER //
// src/pages/company/companyCardTransfer.vue